export enum SurveyStatus {
    Draft = 0,
    Open = 1,
    Closed = 2,
    ReportGenerated = 3,
    Archived = 4
}

export const SurveyStatusLabels: Record<SurveyStatus, string> = {
    [SurveyStatus.Draft]: 'Draft',
    [SurveyStatus.Open]: 'Open',
    [SurveyStatus.Closed]: 'Closed',
    [SurveyStatus.ReportGenerated]: 'Closed Report Generated',
    [SurveyStatus.Archived]: 'Archived'
};

export const SurveyStatusColors: Record<SurveyStatus, string> = {
    [SurveyStatus.Draft]: '#FFAF24',
    [SurveyStatus.Open]: '#FF8C2F',
    [SurveyStatus.Closed]: '#01BD79',
    [SurveyStatus.ReportGenerated]: '#02754a',
    [SurveyStatus.Archived]: '#5c5c5c'
};

export const SurveyStatusCssClasses: Record<SurveyStatus, string> = {
    [SurveyStatus.Draft]: 'survey-draft',
    [SurveyStatus.Open]: 'survey-open',
    [SurveyStatus.Closed]: 'survey-closed',
    [SurveyStatus.ReportGenerated]: 'survey-report-generated',
    [SurveyStatus.Archived]: 'survey-archived'
};

export function isSurveyClosed(status: SurveyStatus): boolean {
    return status === SurveyStatus.Closed || status === SurveyStatus.ReportGenerated;
}
